import { Box, HStack, Text, VStack } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

const ImageSizeMap = {
  small: '55px',
  medium: '60px',
  large: '70px',
  extraLarge: '80px',
};

export const Wrapper = Box.withConfig({ flex: 1 });

export const ImageContainer = Box.withConfig<{ $size?: string }>(({ $size }) => ({
  padding: 0,
  margin: 0,
  marginRight: 3,
  height: $size ? ImageSizeMap[$size] : ImageSizeMap.medium,
  width: $size ? ImageSizeMap[$size] : ImageSizeMap.medium,
  // for quantity badge positioning
  position: 'relative',
  justifyContent: 'center',
}));

export const DetailsContainer = VStack.withConfig({
  flexShrink: 1,
  alignSelf: 'center',
  justifyContent: 'center',
});

export const QuantityBadge = HStack.withConfig({
  position: 'absolute',
  background: theme.token('background-chip'),
  height: 5,
  color: 'white',
  borderRadius: 'full',
  // offset over image borders a bit
  top: '-3px',
  left: '-3px',
  alignItems: 'center',
});

export const ProductName = Text.withConfig({
  variant: 'headerTwo',
  fontSize: { base: '16px', md: '18px' },
  margin: 0,
  padding: 0,
  numberOfLines: 2,
  lineHeight: 'md',
});

export const ProductDescription = Text.withConfig({
  variant: 'copyTwo',
  margin: 0,
  padding: 0,
});

export const Layout = Box.withConfig<{ $inline?: boolean }>(({ $inline }) => ({
  flexDirection: $inline ? 'row' : 'column',
  justifyContent: $inline ? 'flex-start' : 'center',
  alignItems: 'flex-start',
}));

export const SelectionsListItem = Text.withConfig({
  width: 'full',
  fontSize: 'xs',
  lineHeight: 'xs',
});
